"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canPunishUser = exports.canPickWarnLevel = exports.canApplyFullBan = void 0;
exports.mapWarnTemplates = mapWarnTemplates;
exports.buildWarnFlags = buildWarnFlags;
exports.resolveWarnHours = resolveWarnHours;
exports.formatWarnDuration = formatWarnDuration;
var permissions_1 = require("../permissions");
Object.defineProperty(exports, "canApplyFullBan", { enumerable: true, get: function () { return permissions_1.canApplyFullBan; } });
Object.defineProperty(exports, "canPickWarnLevel", { enumerable: true, get: function () { return permissions_1.canPickWarnLevel; } });
Object.defineProperty(exports, "canPunishUser", { enumerable: true, get: function () { return permissions_1.canPunishUser; } });
function mapWarnTemplates(data) {
    const arr = Array.isArray(data) ? data : [];
    const categoriesRaw = arr[3];
    const categories = [];
    if (Array.isArray(categoriesRaw)) {
        for (const cat of categoriesRaw) {
            if (!Array.isArray(cat))
                continue;
            const catFlags = Number(cat[2]) || 0;
            const showRoBan = (catFlags & 1) !== 0;
            const templatesRaw = cat[3];
            const templates = [];
            if (Array.isArray(templatesRaw)) {
                for (const tpl of templatesRaw) {
                    if (!Array.isArray(tpl))
                        continue;
                    templates.push({
                        action: String(tpl[0] ?? ''),
                        label: String(tpl[1] ?? ''),
                        modReasonHint: String(tpl[2] ?? ''),
                        userMessage: String(tpl[3] ?? ''),
                        flags: Number(tpl[4]) || 0,
                        roHours: showRoBan ? (Number(tpl[5]) || 0) : 0,
                        banHours: showRoBan ? (Number(tpl[6]) || 0) : 0,
                    });
                }
            }
            categories.push({
                id: String(cat[0] ?? ''),
                label: String(cat[1] ?? ''),
                flags: catFlags,
                templates,
            });
        }
    }
    return {
        roExtraHours: Number(arr[0]) || 0,
        banExtraHours: Number(arr[1]) || 0,
        uiFlags: Number(arr[2]) || 0,
        categories,
    };
}
function buildWarnFlags(options) {
    let flags = (options.templateFlags & 66) | 1;
    if (options.deletePost) {
        flags |= 4;
    }
    if (options.warnLevel === 'full' && options.canFullBan) {
        flags |= 48;
    }
    else if (options.warnLevel === 'last') {
        flags |= 16;
    }
    if (options.confirmWarnBump) {
        flags |= 512;
    }
    return flags;
}
function resolveWarnHours(input, unit, templateHours, templateFlags, extraHours, extraFlag) {
    const trimmed = input.trim();
    if (trimmed) {
        const parsed = Number.parseInt(trimmed, 10);
        if (!Number.isNaN(parsed) && parsed >= 0) {
            return unit === 'days' ? parsed * 24 : parsed;
        }
    }
    let hours = templateHours;
    if ((templateFlags & extraFlag) !== 0) {
        hours += extraHours;
    }
    return hours;
}
function formatWarnDuration(hours, unit) {
    if (unit === 'days') {
        return String(Math.max(0, Math.round(hours / 24)));
    }
    return String(Math.max(0, hours));
}
